export const JOINREQUEST_LOADING = 'JOINREQUEST_LOADING';
export const GET_ALL_JOIN_REQUESTS = 'GET_ALL_JOIN_REQUESTS';
export const UPDATE_REQUEST_STATUS = 'UPDATE_REQUEST_STATUS';

export const JOINREQUEST_ERROR = 'JOINREQUEST_ERROR';
export const JOINREQUEST_RESET = 'JOINREQUEST_RESET';
export const JOINREQUEST_SUCCESS = 'JOINREQUEST_SUCCESS';
